var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-logo"},[_c('img',{staticClass:"navbar-logo__img",attrs:{"src":_vm.logo,"alt":"logo"}}),_c('transition',{attrs:{"name":"expand"}},[(_vm.expand)?_c('div',{staticClass:"navbar-logo__large-content"},[_c('img',{staticClass:"navbar-logo__large",attrs:{"src":_vm.logo_large,"alt":"logo"}})]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }